import { useLocation } from '../../../../context/LocationContext';
import AddToDigitalBillButton from './digital-bill/AddToDigitalBillButton';
import { useCheckout } from '../../../../context/CheckoutContext';
import EatInOrTakeaway from './EatInOrTakeaway';
import TotalPrice from '../TotalPrice';
import PaymentButtons from './payment/PaymentButtons';
import ErrorBoundary from '../../../../containers/ErrorBoundary';
import NoteButton from './NoteButton';
import React from 'react';
import { useActiveDigitalBill } from '../../../../context/DigitalBillStore';

const Checkout = () => {
  const activeDigitalBill = useActiveDigitalBill();
  const { isDigitalBillEnabled } = useLocation();
  const { showSelectTable } = useCheckout();

  return (
    <div className={`${!showSelectTable && 'border-y border-grey-medium'}`}>
      <div className="flex flex-row overflow-scroll py-2 px-4 gap-3">
        <NoteButton />
        <EatInOrTakeaway />
      </div>
      <TotalPrice />
      <section className="mt-4">
        {isDigitalBillEnabled && activeDigitalBill ? (
          <ErrorBoundary title="Failed to add order to bill">
            <AddToDigitalBillButton activeDigitalBill={activeDigitalBill} />
          </ErrorBoundary>
        ) : (
          <ErrorBoundary title="Failed to complete payment">
            <PaymentButtons />
          </ErrorBoundary>
        )}
      </section>
    </div>
  );
};

export default React.memo(Checkout);
